import { Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { environment } from '../../../../environments/environment';
import { GeneralService } from 'src/app/services/service.index';
import { UtilHelper } from '../../../_helpers/util';

declare const toastr: any;
@Component({
  selector: 'app-observacion',
  templateUrl: './observacion.component.html',
  styleUrls: []
})


export class ObservacionComponent implements OnInit {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  dataResourceLstObs: any[];

  model: any = {
    id: 0,
    descripcion: '',
    modulo: '',
    modulo_id: 0,
    activo: false,

  };

  dataResourceObs: any = [{ modulo: 'FUS' }, { modulo: 'PAC' }, { modulo: 'TRASPASOS' }];
  techoId: number = 0;
  techoIdE: number = 0;
  estado: string = '0';
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  popupVisibleEstado: boolean = false;
  baseUrl = environment.apiEndpoint;
  hasError: any;
  vigencia: any[];
  state_toogle: boolean = false;
  constructor(private _gs: GeneralService) {
    this.vigencia = [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }];

  }

  ngOnInit() {
    this.getObservaciones();
  }

  clearErrors() {
    this.hasError = { descripcion: false, modulo: false, activo: false, modulo_id: false };
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    },);
  }

  getObservaciones() {
    this._gs.getObservacionesLstGeneral().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {          
          this.dataResourceLstObs = result.data;
        }
        else { this.dataResourceLstObs = []; }
      },
      (error) => { console.log('Error', error); });
  }

  showModalAdd() {
    this.state_toogle = false;
    this.clearErrors();
    this.popupVisibleAdd = true;
  }

  saveObservacion() {    
    if (this.model.id == 0) {
      this.model.activo = true;      
      this._gs.postObservacion(this.model).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getObservaciones();
            toastr.success('Observación registrada correctamente.');
            this.popupVisibleAdd = false;
          }
          else if (result.status == 201) {
            toastr.warning(result.data);
          }
        },
        error => { console.log('Error', error); });
    }
    else {      
      this._gs.putObservacion(this.model).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getObservaciones();
            toastr.success('Observación registrada correctamente.');
            this.popupVisibleAdd = false;
          }
          else if (result.status == 201) {
            toastr.warning(result.data);
          }
        },
        error => { console.log('Error', error); });
    }
  }

  showModalEdit(data: any) {
    this.state_toogle = true;
    this.clearErrors();    
    this.model.id = data.id;
    this.model.modulo = data.modulo;
    this.model.activo = data.activo;
    this.model.descripcion = data.descripcion;
    this.popupVisibleAdd = true;
  }

  showModalDelete(id: number){
    this.model.id = id;
    this.popupVisibleDel = true;
  }

  deleteObservacion(){
    {
      this._gs.deleteObservacion(this.model.id).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getObservaciones();
            this.popupVisibleDel = false;
            toastr.success('Registro eliminado correctamente.');
          } else if (result.status == 201) {
            this.getObservaciones();
            this.popupVisibleDel = false;
            toastr.warning(result.data);
          }
          else {
            toastr.warning("otro");
          }
        },
        error => { console.log('Error', error); });
    }
  }

}
